
/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';


import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';
import ReactDOM from 'react-dom';
import { NUMBER_BINARY_OPERATORS } from '@babel/types';

const affOption = [
    { label: 'select Level' }, { label: 1 }, { label: 2 }, { label: 3 }, { label: 4 }, { label: 5 }, { label: 6 }, { label: 7 }
]

class EditableJumper extends Component {

    constructor(props) {

        super(props);
        //this.toggleModal = this.toggleModal.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isModalOpen: false,
            jumpType: null,
            load: props.load,
            jumper: props.jumper,
            type: props.type,
            label: props.type,
            jumpId: props.jumpId,
            editMode: props.editMode,
            JumperId: '',
            loadNum: props.loadNum,
            menuPlacement: "bottom",
            elementWidth: props.elementWidth,
            isDisabled: false,
            options: props.options,
        };

        this.timerId = undefined;
        this.valRef = null;
        this.inputValue = '';
        this.dropdownstyle = {};
    }

    componentWillMount = () => {
        let { editMode } = this.state
        var displayValue = localStorage.getItem("displayOnly");
        var role = localStorage.getItem("role");

        if (displayValue === "true" || role == 'pilot' || role == 'video edit') {
            this.setState({ isDisabled: true })
        }
        ////console.o('CreateJump componentWillMount');
        //this.timerId = setTimeout(this.cancelOrSubmit, 5000) // call the `toggle` function after 5000ms
    }

    componentDidMount = () => {
        ////console.o('in component did mount editable jumper');
        ////console.o(this.valRef);
        if (this.valRef !== null)
            this.valRef.focus();

        this.handleStaffStatusUpdate();
    }

    componentDidUpdate = () => {
        ////console.o('in component did update editable jumper');
        ////console.o(this.valRef);
        if (this.valRef !== null)
            this.valRef.focus();
    }

    handleStaffStatusUpdate = () => {
      console.log('handle staff status update editable jumper');
      // console.log('in Option componenet');
      // console.log(props);
      var activeStaff, thisActiveJumper;
      if (this.props.type === "tandem") {
        if (this.props.label === "I") {
          var tandemInstructorOptions = jumpersStore.getTandemInstructorOptions().filter(
            option =>
              this.props.activeJumperIdsOnLoad.findIndex(
                id => option.value._id === id
              ) === -1
          );
          this.setState({options: tandemInstructorOptions})
        }
        else if (this.props.label === "V") {
          var videographerOptions = jumpersStore.getVideographerOptions().filter(
            option =>
              this.props.activeJumperIdsOnLoad.findIndex(
                id => option.value._id === id
              ) === -1
          );
          this.setState({options: videographerOptions})
        }
      }
      else if (this.props.type === "aff") {
        if (this.props.label === "V") {
          var videographerOptions = jumpersStore.getVideographerOptions().filter(
            option =>
              this.props.activeJumperIdsOnLoad.findIndex(
                id => option.value._id === id
              ) === -1
          );
          this.setState({options: videographerOptions})
        }
        else {
          var affInstructorOptions = jumpersStore.getAffInstructorOptions().filter(
            option =>
              this.props.activeJumperIdsOnLoad.findIndex(
                id => option.value._id === id
              ) === -1
          );
          this.setState({options: affInstructorOptions})
        }
      }
      else if (this.props.type === "coach") {
        var coachOptions = jumpersStore.getCoachOptions()
        .filter(
          option =>
            this.props.activeJumperIdsOnLoad.findIndex(
              id => option.value._id === id
            ) === -1
        );
        this.setState({options: coachOptions})
      }
    }
    // handleChange = (selectedOption, loadNum, jumpId, type,label) => {
    // 	// //alert('handle Change');
    //     //console.o("in handle submit for edit jumps");

    //     this.setState({
    //         JumperId:selectedOption.value._id,
    //         loadNum:loadNum,
    //         jumpId: jumpId,
    //         type:type,
    //         label:label
    //     })

    //     var jumpPostBody ={};
    //     ////alert(JSON.stringify(selectedOption));
    //     //console.o(this.valRef);

    //     this.setState({editMode: !this.state.editMode})

    //     if(type==="tandem"){

    //     	if(label==="I"){
    //     		var jumpPostBody = {instructorId: selectedOption.value._id}
    //     	}
    //     	else if (label==="V"){
    //     		var jumpPostBody = {videographerId: selectedOption.value._id}
    //     	}
    //     	//alert(JSON.stringify(jumpPostBody));
    //     	loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
    //     }
    //     else if(type==="aff"){
    //     	if(label==="I1"){
    //     		var jumpPostBody = {mainInstructorId:selectedOption.value._id}
    //     	}
    //     	else if (label==="I2"){
    //     		var jumpPostBody = {secondaryInstructorId: selectedOption.value._id}
    //     	}
    //     	else if (label==="V"){
    //     		var jumpPostBody = {videographerId: selectedOption.value._id}
    //     	}
    //     	loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
    //     }
    //     else if(type==="coach"){
    //     	if(label==="Coach"){
    //         	var jumpPostBody = {coachId: selectedOption.value._id};
    //         	loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
    //     	}
    //     	else if (label==="Jumper"){
    //     		var jumpPostBody = {jumperId: selectedOption.value._id};
    //         	loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
    //     	}
    //     }

    // }


    handleChange = (selectedOption, loadNum, jumpId, type, label) => {
        //alert('in handleChange');
        //console.o("in handle submit for edit jumps");
        this.setState({ editMode: !this.state.editMode })
        if (selectedOption.value !== undefined) {


            if (type === "tandem") {

                if (label === "I") {
                    var jumpPostBody = { instructorId: selectedOption.value._id }
                }
                else if (label === "V") {
                    var jumpPostBody = { videographerId: selectedOption.value._id }
                }
                ////alert(JSON.stringify(jumpPostBody));
                loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
            }
            else if (type === "aff") {
                if (label === "I1") {
                    //alert('in instructor 1')
                    var jumpPostBody = { mainInstructorId: selectedOption.value._id }
                }
                else if (label === "I2") {
                    //alert('in instructor 2');
                    var jumpPostBody = { secondaryInstructorId: selectedOption.value._id }
                }
                else if (label === "V") {
                    var jumpPostBody = { videographerId: selectedOption.value._id }
                }
                else if (label === "S") {
                    var jumpPostBody = { studentId: selectedOption.value._id }
                }
                loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
            }
            else if (type === "coach") {
                if (label === "C") {
                    var jumpPostBody = { coachId: selectedOption.value._id };
                    loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
                }
                else if (label === "J") {
                    var jumpPostBody = { jumperId: selectedOption.value._id };
                    loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
                }
            }
        }
        //this.cancelOrSubmit();
        //clearTimeout(this.timerId);
        // this.timerId = setTimeout(this.cancelOrSubmit(selectedOption, loadNum, jumpId, type,label), 5000);
        //this.timerId = setTimeout(this.cancelOrSubmit, 5000);
    }

    handleAffChange = (selectedOption, loadNum, jumpId, type, label) => {
        //console.o("in handle submit for edit jumps");
        // this.setState({editMode: !this.state.editMode})
        // this.setState({
        //     JumperId: selectedOption.value._id,
        //     loadNum: loadNum,
        //     jumpId: jumpId,
        //     type: type,
        //     label: label,
        //     editMode: !this.state.editMode
        // })
        //clearTimeout(this.timerId);
        //this.timerId = setTimeout(this.cancelOrSubmit, 5000);
    }

    cancelOrSubmit = () => {
        //console.o(this.timerId)
        var ID = this.state.JumperId;
        var loadNum = this.state.loadNum;
        var jumpId = this.state.jumpId;
        var type = this.state.type;
        var label = this.state.label;

        var jumpPostBody = {};
        //console.o(this.valRef);

        if (type === "tandem") {

            if (label === "I") {
                var jumpPostBody = { instructorId: ID }
            }
            else if (label === "V") {
                var jumpPostBody = { videographerId: ID }
            }
            ////alert(JSON.stringify(jumpPostBody));
            loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
        }
        else if (type === "aff") {
            if (label === "I1") {
                //alert('instructor 1')
                var jumpPostBody = { mainInstructorId: ID }
            }
            else if (label === "I2") {
                //alert('instructor 2');
                var jumpPostBody = { secondaryInstructorId: ID }
            }
            else if (label === "V") {
                var jumpPostBody = { videographerId: ID }
            }
            loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
        }
        else if (type === "coach") {
            if (label === "C") {
                var jumpPostBody = { coachId: ID };
                loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
            }
            else if (label === "J") {
                var jumpPostBody = { jumperId: ID };
                loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
            }
        }
    }

    // cancelOrSubmit = (selectedOption, loadNum, jumpId, type,label) => {
    //     //console.o("in handle submit for edit jumps");
    //     var jumpPostBody = {};
    //     //console.o(this.valRef);
    //     // this.setState({ editMode: !this.state.editMode })
    //     if (type === "tandem") {

    //         if (label === "I") {
    //             var jumpPostBody = { instructorId: selectedOption.value._id }
    //         }
    //         else if (label === "V") {
    //             var jumpPostBody = { videographerId: selectedOption.value._id }
    //         }
    //         //alert(JSON.stringify(jumpPostBody));
    //         loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
    //     }
    //     else if (type === "aff") {
    //         if (label === "I1") {
    //             var jumpPostBody = { mainInstructorId: selectedOption.value._id }
    //         }
    //         else if (label === "I2") {
    //             var jumpPostBody = { secondaryInstructorId: selectedOption.value._id }
    //         }
    //         else if (label === "V") {
    //             var jumpPostBody = { videographerId: selectedOption.value._id }
    //         }
    //         loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
    //     }
    //     else if (type === "coach") {
    //         if (label === "Coach") {
    //             var jumpPostBody = { coachId: selectedOption.value._id };
    //             loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
    //         }
    //         else if (label === "Jumper") {
    //             var jumpPostBody = { jumperId: selectedOption.value._id };
    //             loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
    //         }
    //     }

    // }

    changeJumper = (event) => {

        if (!this.state.isDisabled) {
            ////console.o(event.detail);
            //alert('change Jumper');

            //console.o(this.valRef);
            if (!this.state.editMode) {
                this.setState({
                    editMode: true
                })
            }
            if (ReactDOM.findDOMNode(this).getBoundingClientRect().y > window.innerHeight / 2) {
                this.setState({ menuPlacement: "top" });
            }
            else {
                this.setState({ menuPlacement: "bottom" });
            }
        } else {
            return
        }

    }

    onBlur = () => {
        //alert('blurring');
        this.setState({
            editMode: false
        })
    }


    render() {
        let SelectInput = (props) => (<Select model={props.model} name={props.name} placeholder={props.placeholder} options={props.options} onChange={props.onChange} isMulti={props.isMulti} components={props.components} styles={props.styles} theme={(theme) => ({
            ...theme,
            colors: {
                ...theme.colors,
                primary: '#E7F2F6',
                // primary75: 'red',
                // primary50: 'blue',
                primary25: 'blue', // hover option
                // danger: 'green',
                dangerLight: '#59C5DC', // cross background
                neutral0: 'rgb(0, 65, 157)', // background container
                // neutral5: 'pink',
                neutral10: 'blue', // selected option background
                neutral20: '#E7F2F6', // border input without hover
                neutral30: '#E7F2F6', // border input with hover
                neutral40: 'orange',
                neutral50: '#E7F2F6', // default text
                neutral60: '#E7F2F6', // down icon
                neutral70: 'yellow',
                neutral80: '#E7F2F6', //selected text color
                // neutral90: 'rgb(0, 65, 157)',
            },
        })} />);
       
        return (
      
            <React.Fragment>
                {
                    !this.state.editMode ?
                        // <button className="btn lightBlueButton jumper-name" onClick={(e) => { e.preventDefault(); this.changeJumper(); }} type="submit" disabled={this.props.disabled}>
                        <div className={'name-container'}  onClick={(e) => { e.preventDefault(); this.changeJumper(this.props.isCompleted); }}
                            disabled={this.props.disabled}>
                            {this.props.jumper.firstname !== "NONE" ?
                                <div>
                                
                                <div style={!this.props.hasObserevers||(this.props.loadsToShow===6 && this.props.columnsPerGroup===2 && this.props.type==="pilot")?
                                 { display: 'flex',justifyContent:"center"} : {}} >
                                    {this.props.label}:
                                    <strong style={!this.props.hasObserevers ? {display: 'flex'} : {}} >

                                        <span>{this.props.jumper.nickname}</span>
                                        <span style={{marginLeft:"6px"}}> 
                                        {this.props.jumper.lastname !== undefined && this.props.jumper.lastname !== "" && 
                                        this.props.jumper.lastname !== null ? this.props.jumper.lastname.substr(0, 1) : null}
                                        </span>

                                    </strong>
                                    {this.props.type === "pilot" ? <strong>
                                        <span style={{marginLeft:"4px"}}>
                                        {!this.props.hasObserevers ? this.props.jumper.memberId : "" }
                                        </span>
                                    </strong>:""}
                                    <br/>
                                </div>
                                    {this.props.type !== "pilot" ? <strong>
                                        <span>
                                        {!this.props.hasObserevers ? ` `: "" }
                                        {!this.props.hasObserevers ? this.props.jumper.memberId : "" }
                                        </span>
                                    </strong>:""}
                                {this.props.type != 'tandem' ?
                                        <div className="memberId" >
                                            <span className="inline-Id-and-gear" style={{height:"100%"}} >
                                               {this.props.hasObserevers ? this.props.jumper.memberId :""}
                                            </span>
                                        </div>
                                        :
                                        <React.Fragment>{this.props.videoType === "both" || this.props.videoType === "wristcam" ? <i className="fa fa-3x fa-video-camera" style={{ color: "green" }}> </i> : null}</React.Fragment>

                                    }
                                </div>
                                :
                                <div ><i className="fa fa-plus tandem-font-size"></i> <strong  className="tandem-font-size">{this.props.label}</strong></div>
                            }
                        </div>
                        //</button>
                        :
                        // <button className="btn lightBlueButton jumper-name"  disabled={this.props.disabled}>
                        // <button className="btn editable-Jumper" disabled={this.props.disabled} style={{position:"absolute",bottom:"2px",padding :0}}>
                        <button className="btn editable-Jumper" disabled={this.props.disabled} style={this.props.elementWidth ? this.props.elementWidth : { width: '170px' }}>

                            <LocalForm form="editjumpers" model="editjumpers" getDispatch={dispatch => this.formDispatch = dispatch} >
                                <Select model=".jumper" name="jumper" ref={(value) => this.valRef = value}
                                    options={this.state.options}
                                    onChange={(selectedOption) => this.handleChange(selectedOption, this.props.loadNum, this.props.jumpId, this.props.type, this.props.label)}
                                    menuPortalTarget={document.body}
                                    menuPosition="absolute"
                                    menuPlacement={this.state.menuPlacement}
                                    onBlur={this.onBlur}
                                />
                            </LocalForm>
                        </button>

                }
            </React.Fragment>
        );
    }
}

export default EditableJumper
